import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
    Badge,
    Breadcrumb,
    Card,
    Col,
    Divider,
    Image,
    List,
    Row,
    Space
} from "antd";

import {
    fetchUserPurchasedCollections,
    setFetchPurchasedCollectionStatus
} from "../../actions/user";
import { HomeOutlined } from "@ant-design/icons";
import moment from "moment";
import CreatedCollectionList from "../../Components/CreatedCollectionList";
import CourseFindClassCode from "../../Components/CourseFindClassCode";
import TradeMarkBadge from "../../Components/TradeMarkBadge";
import { fetchUserCreatedCollections } from "../../actions/contentCreation";
class PurchasedContent extends Component {
    breadcrumbConfig = () => {
        function itemRender(route, params, routes, paths) {
            const last = routes.indexOf(route) === routes.length - 1;
            return last ? (
                <span>{route.breadcrumbName}</span>
            ) : (
                <Link to={route.path}>{route.breadcrumbName}</Link>
            );
        }
        return {
            itemRender: itemRender,
            routes: [
                {
                    path: "/",
                    breadcrumbName: "Home"
                },
                {
                    path: "/collections/",
                    breadcrumbName: "Courses"
                },
                {
                    path: "/purchased-content/",
                    breadcrumbName: "Purchased Content"
                }
            ]
        };
    };

    componentWillMount = () => {
        if (
            this.props.isAuthenticated &&
            this.props.fetchPurchasedCollectionStatus == "NOT LOADED"
        ) {
            this.props.fetchUserPurchasedCollections(this.props.user.id);
        }
    };

    componentDidUpdate = (prevProps) => {
        if (
            prevProps.isAuthenticated != this.props.isAuthenticated &&
            this.props.isAuthenticated &&
            this.props.fetchPurchasedCollectionStatus == "NOT LOADED"
        ) {
            this.props.fetchUserPurchasedCollections(this.props.user.id);
        }
    };

    componentWillUnmount = () => {
        this.props.setFetchPurchasedCollectionStatus("NOT LOADED");
    };

    componentDidMount() {
        if (this.props.user) {
            this.props.fetchUserCreatedCollections(this.props.user.id);
        }
    }

    render() {
        if (
            this.props.collections == null ||
            this.props.fetchPurchasedCollectionStatus == "NOT LOADED" ||
            this.props.fetchPurchasedCollectionStatus == "LOADING"
        ) {
            return (
                <div id="purchased-content-page">
                    <Space className="ant-space-responsive">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <Link to="/">
                                    <HomeOutlined />
                                </Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>My Courses</Breadcrumb.Item>
                        </Breadcrumb>
                    </Space>

                    <Divider orientation="left" orientationMargin="0">
                        Recently Visited
                    </Divider>
                    <Row gutter={[16, 16]}>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                    </Row>

                    <Divider orientation="left" orientationMargin="0">
                        Purchased
                    </Divider>
                    <Row gutter={[16, 16]}>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                    </Row>

                    <Divider orientation="left" orientationMargin="0">
                        For Class / Certificates
                    </Divider>
                    <Row gutter={[16, 16]}>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                        <Col span={6}>
                            <Card loading={true}></Card>
                        </Col>
                    </Row>
                </div>
            );
        }

        const ImageOnly = ({ collection }) => {
            return (
                <>
                    <Image
                        preview={false}
                        src={collection.coverImage.image}
                        fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                    />
                    {collection.mlBoostedCollection && <TradeMarkBadge />}
                </>
            );
        };

        const CertifiationCoverImage = ({ collection }) => {
            return (
                <Badge.Ribbon text="Certified" color="green">
                    <ImageOnly collection={collection} />
                </Badge.Ribbon>
            );
        };

        const EvaluationCoverImage = ({ collection }) => {
            return (
                <Badge.Ribbon text="Evaluation Period" color="red">
                    <ImageOnly collection={collection} />
                </Badge.Ribbon>
            );
        };

        const CoverImage = ({ collection }) => {
            if (collection.userCertification) {
                return <CertifiationCoverImage collection={collection} />;
            } else if (
                collection.userEvaluation &&
                !collection.userEvaluation.isExpired
            ) {
                return <EvaluationCoverImage collection={collection} />;
            } else {
                return <ImageOnly collection={collection} />;
            }
        };

        return (
            <div id="purchased-content-page">
                <Space className="ant-space-responsive flex space-between align-center">
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link to="/">
                                <HomeOutlined />
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>My Courses</Breadcrumb.Item>
                    </Breadcrumb>
                    <CourseFindClassCode />
                </Space>

                {this.props.isAuthenticated &&
                    this.props.user.isContentCreator && (
                        <>
                            <Divider orientation="left" orientationMargin="0">
                                Authored Courses
                            </Divider>

                            <CreatedCollectionList
                                createdCollectionList={
                                    this.props.createdCollections
                                }
                            />
                        </>
                    )}

                <Divider orientation="left" orientationMargin="0">
                    Recently Visited
                </Divider>
                <List
                    grid={{
                        gutter: [16, 16],
                        xs: 1,
                        sm: 2,
                        md: 4,
                        lg: 3,
                        xl: 4,
                        xxl: 4
                    }}
                    pagination={{
                        hideOnSinglePage: true,
                        disabled: true,
                        pageSize: 4
                    }}
                    dataSource={this.props.collections.recent_visits}
                    renderItem={(visit) => (
                        <List.Item key={visit.collection.id}>
                            <Link
                                to={
                                    visit.collection.userCertification ||
                                        (visit.collection.userEvaluation &&
                                            !visit.collection.userEvaluation
                                                .isExpired)
                                        ? `${visit.collection.url}certification/`
                                        : `${visit.collection.url}`
                                }>
                                <Card
                                    cover={
                                        <CoverImage
                                            collection={visit.collection}
                                        />
                                    }>
                                    <Card.Meta
                                        title={visit.collection.name}
                                        description={`Last visited on ${moment(
                                            new Date(visit.viewedAt)
                                        ).format("MM/DD/YYYY hh:mm A")}`}
                                    />
                                </Card>
                            </Link>
                        </List.Item>
                    )}
                />

                <Divider orientation="left" orientationMargin="0">
                    Purchased
                </Divider>
                <List
                    grid={{
                        gutter: [16, 16],
                        xs: 1,
                        sm: 2,
                        md: 4,
                        lg: 3,
                        xl: 4,
                        xxl: 4
                    }}
                    pagination={{
                        pageSize: 4
                    }}
                    dataSource={this.props.collections.purchased}
                    renderItem={(collection) => (
                        <List.Item key={collection.id}>
                            <Link
                                to={
                                    collection.userCertification ||
                                        (collection.userEvaluation &&
                                            !collection.userEvaluation.isExpired)
                                        ? `${collection.url}certification/`
                                        : `${collection.url}`
                                }>
                                <Card
                                    cover={
                                        <CoverImage collection={collection} />
                                    }>
                                    <Card.Meta title={collection.name} />
                                </Card>
                            </Link>
                        </List.Item>
                    )}
                />
                <Divider orientation="left" orientationMargin="0">
                    For Class / Certificates
                </Divider>
                <List
                    grid={{
                        gutter: [16, 16],
                        xs: 1,
                        sm: 2,
                        md: 4,
                        lg: 3,
                        xl: 4,
                        xxl: 4
                    }}
                    pagination={{
                        pageSize: 4
                    }}
                    dataSource={this.props.collections.valid}
                    renderItem={(collection) => (
                        <List.Item key={collection.id}>
                            <Link
                                to={
                                    collection.userCertification ||
                                        (collection.userEvaluation &&
                                            !collection.userEvaluation.isExpired)
                                        ? `${collection.url}certification/`
                                        : `${collection.url}`
                                }>
                                <Card
                                    cover={
                                        <CoverImage collection={collection} />
                                    }>
                                    <Card.Meta title={collection.name} />
                                </Card>
                            </Link>
                        </List.Item>
                    )}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.userReducer.isAuthenticated,
        createdCollections: state.contentCreationReducer.userCreatedCollections,
        fetchingUser: state.userReducer.fetchingUser,
        user: state.userReducer.user,
        fetchPurchasedCollectionStatus:
            state.userReducer.fetchPurchasedCollectionStatus,
        collections: state.userReducer.purchasedCollections
    };
};

export default connect(mapStateToProps, {
    fetchUserPurchasedCollections,
    fetchUserCreatedCollections,
    setFetchPurchasedCollectionStatus
})(PurchasedContent);
